export const ACCOUNTS_GET_ACCOUNT_OPEN_MODAL = "ACCOUNTS_GET_ACCOUNT_OPEN_MODAL";
export const ACCOUNTS_GET_ACCOUNT_REQUEST = "ACCOUNTS_GET_ACCOUNT_REQUEST";
export const ACCOUNTS_GET_ACCOUNT_RESULT = "ACCOUNTS_GET_ACCOUNT_RESULT";